import axios from 'axios'

async function resetWebhookSecret(projectId) {
  return (await axios.post(`/projects/${projectId}/settings/reset_webhook_secret`)).data
}

export default {
  resetWebhookSecret
}